import { apiGet, apiPost, apiPut, apiDelete } from '@/services/api/apiClient';

export interface EmployeeInfo {
  _id: string;
  name: string;
  empId: string;
  role: string;
  email: string;
  mobile: string;
}

export interface StatusEnquiry {
  _id: string;
  employeeId: EmployeeInfo;
  message: string;
  createdBy: EmployeeInfo;
  isActive: boolean;
  isDeleted: boolean;
  createdAt: string;
  updatedAt: string;
}

export interface StatusEnquiryFormData {
  employeeId: string;
  message: string;
  // isActive?: boolean;
}

export interface StatusEnquiryListParams {
  page?: number;
  limit?: number;
  employeeId?: string;
  search?: string;
  isActive?: boolean;
}

export interface StatusEnquiryListResponse {
  success: boolean;
  message: string;
  data: {
    docs: StatusEnquiry[];
    totalDocs: number;
    limit: number;
    totalPages: number;
    page: number;
    pagingCounter: number;
    hasPrevPage: boolean;
    hasNextPage: boolean;
    prevPage: number | null;
    nextPage: number | null;
  };
}

export interface StatusEnquiryResponse {
  success: boolean;
  message: string;
  data: StatusEnquiry;
}

class StatusEnquiryService {
  private baseUrl = '/status-enquiries';

  async getStatusEnquiries(params: StatusEnquiryListParams = {}): Promise<StatusEnquiryListResponse> {
    const queryParams = new URLSearchParams();

    if (params.page) queryParams.append('page', params.page.toString());
    if (params.limit) queryParams.append('limit', params.limit.toString());
    if (params.employeeId) queryParams.append('employeeId', params.employeeId);
    if (params.search) queryParams.append('search', params.search);
    if (params.isActive !== undefined) queryParams.append('isActive', params.isActive.toString());

    const url = `${this.baseUrl}${queryParams.toString() ? `?${queryParams.toString()}` : ''}`;
    return apiGet<StatusEnquiryListResponse>(url);
  }

  async createStatusEnquiry(data: StatusEnquiryFormData): Promise<StatusEnquiryResponse> {
    return apiPost<StatusEnquiryResponse>(this.baseUrl, data);
  }

  async updateStatusEnquiry(id: string, data: StatusEnquiryFormData): Promise<StatusEnquiryResponse> {
    return apiPut<StatusEnquiryResponse>(`${this.baseUrl}/${id}`, data);
  }

  async deleteStatusEnquiry(id: string): Promise<{ success: boolean; message: string }> {
    return apiDelete<{ success: boolean; message: string }>(`${this.baseUrl}/${id}`);
  }

  async getStatusEnquiryById(id: string): Promise<StatusEnquiryResponse> {
    return apiGet<StatusEnquiryResponse>(`${this.baseUrl}/${id}`);
  }
}

export const statusEnquiryService = new StatusEnquiryService();
